<template>
  <div class="home">
    <div class="row big-margin">
      <div class="col-9 d-flex align-items-center">
        <p class="lead">
          <span class="font-weight-normal">ANTON VON HEISELER</span> is a director based in berlin. <br>
          <span class="font-weight-normal">contact@antonvonheiseler.com</span>
        </p>


      </div>
    </div>
    <div class="row">
      <div class="col-12 col-lg-4 col-md-6 mt-4 c-pointer">
        <img class="pointer img-fluid" @click="$router.push('/153METER/')"
             src="@/assets/01.jpg"/>
      </div>
      <div class="col-12 col-lg-4 col-md-6 mt-4 c-pointer">
        <img class="pointer img-fluid" @click="$router.push('/mountainmaiden/')"
             src="https://firebasestorage.googleapis.com/v0/b/anton-von-heiseler.appspot.com/o/blackmountain.jpg?alt=media&token=79f87c5f-f7c3-4074-b8eb-4f9361e7079f"/>
      </div>
      <div class="col-12 col-lg-4 col-md-6 mt-4 c-pointer">
        <img class="pointer img-fluid" @click="$router.push('/postmortem/')"
             src="https://firebasestorage.googleapis.com/v0/b/anton-von-heiseler.appspot.com/o/postmortem-01.jpg?alt=media&token=70e13f4e-3e2c-44b9-bd8e-99a524970a8c"/>
      </div>
      <div class="col-12 col-lg-4 col-md-6 mt-4 c-pointer">
        <img class="pointer img-fluid" @click="$router.push('/derigel/')"
             src="https://firebasestorage.googleapis.com/v0/b/anton-von-heiseler.appspot.com/o/igel.jpg?alt=media&token=f985b3ae-1ca4-4d01-af46-181c97e70c46"/>
      </div>
      <div class="col-12 col-lg-4 col-md-6 mt-4 c-pointer">
        <img class="pointer img-fluid" @click="$router.push('/blackmountain/')"
             src="https://firebasestorage.googleapis.com/v0/b/anton-von-heiseler.appspot.com/o/52.jpg?alt=media&token=1e0941ff-0beb-4486-9230-8d42e45fca92"/>
      </div>
      <div class="col-12 col-lg-4 col-md-6 mt-4 c-pointer">
        <img class="pointer img-fluid" @click="$router.push('/untitled/')"
             src="https://firebasestorage.googleapis.com/v0/b/anton-von-heiseler.appspot.com/o/untitled.jpg?alt=media&token=67a100cb-0163-4744-af2a-a12270f371c7"/>
      </div>


<!--      <div class="col-12 col-lg-4 col-md-6 mt-4 c-pointer">-->
<!--        <img class="pointer img-fluid" @click="$router.push('/premedicatedmurder/')"-->
<!--             src="https://firebasestorage.googleapis.com/v0/b/anton-von-heiseler.appspot.com/o/premedicated.jpg?alt=media&token=7c7e4855-4b1e-4b66-94ab-a794013e212f"/>-->
<!--      </div>-->
    </div>
  </div>

</template>

<script>
export default {
  name: "home"
}
</script>

<style scoped>

.big-margin {
  margin-top: 5vh;
}

.pointer:hover {
  cursor: pointer;
}

.c-pointer:hover img {
  opacity: 0.9;
  -webkit-transition: .3s ease-in-out;
  transition: .3s ease-in-out;
}

</style>
